

























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import TwoForOneIcon from '@/components/icons/offer-types/TwoForOne.vue';
import SpecificDiscountIcon from '@/components/icons/offer-types/SpecificDiscount.vue';
import BirthdayOfferIcon from '@/components/icons/offer-types/BirthdayOffer.vue';
import GeneralOfferIcon from '@/components/icons/offer-types/GeneralOffer.vue';

import { Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import { TSpecialCoinOfferType, SpecialOfferTypeEnum } from '@/models/offer';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import { IBusinessType } from '@/models/business';
import segmentIo from '@/utils/segment.io';
import { EOfferCreationStepSlug } from '../OfferCreation.vue';

@Component({
  components: {
    Typography,
    FilledButton,
    SelectionBox,
    TwoForOneIcon,
    SpecificDiscountIcon,
    BirthdayOfferIcon,
    GeneralOfferIcon
  }
})
export default class ChangeTypeReferral extends Vue {
  @Prop(String) defaultValue?: TSpecialCoinOfferType;
  @Prop(Number) lengthListBirthday!: number;

  selectedType = this.defaultValue || '';

  IBusinessType = IBusinessType;
  SpecialOfferTypeEnum = SpecialOfferTypeEnum;

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return 'offers.selectTypeV2';
  }

  get disabledNext() {
    return (
      !this.selectedType ||
      (this.lengthListBirthday > 0 &&
        this.selectedType === SpecialOfferTypeEnum.BIRTHDAY)
    );
  }

  get selectionBoxClass() {
    return { '--online-only': this.birthdayIsDisabled };
  }

  get business() {
    const store = this.$store.getters['business/getBusinessInfo'];

    if (store) {
      return store.business || {};
    }

    return {};
  }

  get birthdayIsDisabled() {
    return (
      this.business.country !== 'United States' ||
      this.business.type === IBusinessType.ONLINE
    );
  }

  scrollToTop() {
    const el = document.querySelector('.container-scrollable');
    if (el) el.scrollTo({ top: 0 });
  }

  next() {
    this.$router.replace({
      query: { type: this.selectedType }
    });

    this.$emit('goToStep', {
      redirectToSlug: EOfferCreationStepSlug.FORM_OFFER
    });
    segmentIo.page('Special Coin Offers/Creation/Form Offer');

    this.scrollToTop();
  }

  @Watch('selectedType')
  selectedTypeChange(newValue: string) {
    segmentIo.track('Selected Offer Type', { Type: newValue });
    this.$emit('changeType', newValue);
  }
}
